interface WarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
}

const WarningModal: React.FC<WarningModalProps> = ({ isOpen, onClose, message }) => {
    if (!isOpen) return null;
  
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg w-96">
          {/* Warning Header */}
          <h2 className="text-lg font-semibold text-yellow-500">⚠ Warning</h2>
          
          {/* Message */}
          <p className="mt-2 text-gray-700">{message}</p>
  
          {/* Close Button */}
          <div className="mt-4 flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-yellow-500 text-white rounded-md hover:bg-yellow-600"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  export default WarningModal;